<div class="list-group list-group-light mt-5 mb-5 dashboard-action-buttons">
    <span class=" d-block mb-2 subtitle-1--weight-regular">Get Started</span>
    <button type="button"  class="list-group-item list-group-item-action  pl-3 pr-5 border-0 mb-3 dashboard--btn"  style="cursor: default;">
      <app-in-person-hybrid-icon class="mr-2"></app-in-person-hybrid-icon>
        <div class="d-flex flex-column">            
          <a target="_blank" href="https://docs.paybee.io/home/getting-started/hybrid-events" class="p-0 mb-1 subtitle-1--weight-regular">Hybrid/In-Person Events</a>
          <span class="body-2">Learn how to set up and run 
            <a target="_blank" href="https://docs.paybee.io/home/getting-started/hybrid-events">Hybrid</a> and 
            <a target="_blank" href="https://docs.paybee.io/home/getting-started/in-person-events">In-Person</a> Events.</span>
        </div>
        <a target="_blank" href="https://docs.paybee.io/home/getting-started/hybrid-events">
          <i class="fas fa-angle-right  icon-dashboadrBtn"style="font-size:20px"></i>
        </a> 
    </button>
    <button type="button"  class="list-group-item list-group-item-action  pl-3 pr-5 border-0 mb-3 dashboard--btn" style="cursor: default;">
      <app-icon-virtual class="mr-2"></app-icon-virtual>
      <div class="d-flex flex-column">            
        <a target="_blank" href="https://docs.paybee.io/home/getting-started/virtual-event" class="p-0 mb-1 subtitle-1--weight-regular">Virtual Event</a>
        <span class="body-2">Learn how to set up and run Virtual Events from invitations to reports.</span>
      </div>
      <a target="_blank" href="https://docs.paybee.io/home/getting-started/virtual-event">
        <i class="fas fa-angle-right  icon-dashboadrBtn"style="font-size:20px"></i>
      </a>
    </button>
    <button type="button"  class="list-group-item list-group-item-action pl-3 pr-5 border-0 mb-3 dashboard--btn" style="cursor: default;">
      <app-gavel-auction class="mr-2"></app-gavel-auction>
      <div class="d-flex flex-column">          
        <a target="_blank" href="https://docs.paybee.io/home/guides/silent-auction-guide" class="p-0 mb-1 subtitle-1--weight-regular">Silent Auction</a>
        <span class="body-2">Also called Online Auction. Let us walk you through the set up and running one.</span> 
      </div>
      <a target="_blank" href="https://docs.paybee.io/home/guides/silent-auction-guide">
        <i class="fas fa-angle-right icon-dashboadrBtn"></i>
      </a>
    </button>
    <button type="button"  class="list-group-item list-group-item-action pl-3 pr-5 border-0 mb-3 dashboard--btn" style="cursor: default;">
      <app-icon-light-bulb class="mr-2"></app-icon-light-bulb>
      <div class="d-flex flex-column">
        <a target="_blank" href="https://docs.paybee.io/home/getting-started/campaigns" class="p-0 mb-1 subtitle-1--weight-regular">Campaigns</a>
        <span class="body-2">Explore the different campaigns types and their superpowers.</span> 
      </div>
      <a target="_blank" href="https://docs.paybee.io/home/getting-started/campaigns">
        <i class="fas fa-angle-right icon-dashboadrBtn"></i>
      </a>  
    </button>
  </div>


